/** This form's `kind` in `CreateEntityWizardStore` — a `submitRequest`/`resetRequest` only triggers this component's handlers when its `tab` matches. */
export const STUDY_FORM_KIND = 'study' as const;

/** Shape of the Study tab's Signal Form model. Same rationale as `FacilityFormValue` — flat, plain-string fields, no shared/Material types. */
export interface StudyFormValue {
    name: string;
    label: string;
    description: string;
    status: string;
}

export const DEFAULT_STUDY_FORM_VALUE: StudyFormValue = {
    name: '',
    label: '',
    description: '',
    status: ''
};
